import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {InsuranceCompany} from "../../../shared/interface/insurance-company";
import {ReplaySubject} from "rxjs";
import {REGISTRATION_STATUS_REGISTERED} from "../../../shared/services/dict.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {AgentsProfileHiperioService} from "../../../shared/services/agents-profile-hiperio.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {delay, takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {HiperioConfigDirectService} from "../../../shared/services/hiperio-config-direct.service";
import {Registration} from "../../../shared/interface/registration";

export interface ChangeRegistrationDialogData {
  insuranceCompany: InsuranceCompany;
  hiperioConfigDirectId: number;
  registration?: Registration;
}

@Component({
  selector: 'app-change-registration-hiperio-direct',
  templateUrl: './change-registration-hiperio-direct.component.html',
  styleUrls: ['./change-registration-hiperio-direct.component.scss']
})
export class ChangeRegistrationHiperioDirectComponent implements OnInit, OnDestroy {

  changeRegistrationForm: FormGroup;
  insuranceCompany: InsuranceCompany;
  hiperioConfigDirectId: number;
  processingRequest = false;
  registrationControl: FormControl;
  readonly REGISTRATION_STATUS_REGISTERED = REGISTRATION_STATUS_REGISTERED;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<ChangeRegistrationHiperioDirectComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeRegistrationDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private hiperioConfigDirectService: HiperioConfigDirectService,
    private snack: MatSnackBar,
  ) {
    this.insuranceCompany = data.insuranceCompany;
    this.hiperioConfigDirectId = data.hiperioConfigDirectId;
    this.changeRegistrationForm = fb.group({
      registration: this.registrationControl = fb.control('')
    });
    this.registrationControl.setValue(data.registration?.uuid);
  }

  ngOnInit(): void {
    this.changeRegistrationForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

  sendForm(): void {
    this.processingRequest = true;

    this.hiperioConfigDirectService.sendUpdateRegistration(this.changeRegistrationForm.value, this.hiperioConfigDirectId)
      .subscribe(() => {
        this.snack.open('Pomyślnie zmieniono rejestracjie', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas aktualizacji salda wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });


      })
    ;
  }

}
